// removed by extract-text-webpack-plugin
module.exports = {"skeleton":"styles__skeleton___97MFo","skeleton-loading":"styles__skeleton-loading___1pAIh","whiteBackgroundSkeleton":"styles__whiteBackgroundSkeleton___1ME5H","skeleton-loader-gradient":"styles__skeleton-loader-gradient___3h9pe","table":"styles__table___10G_5","tableHeader":"styles__tableHeader___1z4vS","itemValue":"styles__itemValue___cYRHA","itemsClasses":"styles__itemsClasses___1Zwz5","tableBody":"styles__tableBody___1v9p8","mainSectionSkeleton":"styles__mainSectionSkeleton___1GBtm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Skeleton/ProductsContractsSkeleton/styles.css
// module id = 2536
// module chunks = 0